import { getEventTicketCodes } from 'controller/wallet/getEventTicketCodes'
import { getPastEvents } from 'controller/wallet/getPastEvents'
import { getUpcomingEvents } from 'controller/wallet/getUpcomingEvents'
import { getUpcomingGoodsServices } from 'controller/wallet/getUpcomingGoodsServices'

import { getPastGoodsServices } from './getPastGoodsServices'

export const WalletController = {
  getPastEvents,
  getUpcomingEvents,
  getPastGoodsServices,
  getEventTicketCodes,
  getUpcomingGoodsServices,
}
